import styled from "styled-components";
import facepaint from "facepaint";

const breakpoints = [768];
export const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`));

function getCssProps(props) {
    const propertiesToRemove = ["children", "forwardedComponent", "forwardedRef", "theme", "as", "src"];
    const filteredEntries = Object.entries(props).filter(([key]) => !propertiesToRemove.includes(key));
    return Object.fromEntries(filteredEntries);
}

export const Img = styled.img(props => mq({ ...getCssProps(props) }));
export const Box = styled.div(props => mq({ display: "flex", flexDirection: "column", width: "auto", ...getCssProps(props) }));
export const Text = styled.p(props => mq({ fontSize: "14px", margin: 0, color: "#1B1E1C", display: "inline-block", ...getCssProps(props) }));

const baseBtnStyles = {
    fontSize: ["12px", "14px"],
    height: ["50px", "60px"],
    borderRadius: "5px",
    textAlign: "center",
    fontWeight: 700,
    display: "inline-block",
    padding: "0 18px"
};

const primaryBtnStyles = {
    ...baseBtnStyles,
    background: "#003D4C",
    ":hover": { background: "#3F879E" },
    color: "white"
};

const secondaryBtnStyles = {
    ...baseBtnStyles,
    background: "white",
    border: "1px solid #003D4C",
    ":hover": { border: "1px solid #3F879E" },
    color: "#1B1E1C"
};

const primaryBtnDisabled = {
    cursor: "not-allowed",
    background: "#CFD0CF",
    color: "white",
    border: "none",
    ":hover": "none"
};

export const Button = styled.button(props => {
    const variantStyles = (() => {
        const variant = props.variant || "primary";
        if (variant === "primary") {
            if (props.isDisabled) return { ...primaryBtnStyles, ...primaryBtnDisabled };
            return primaryBtnStyles;
        }
        if (variant === "secondary") return secondaryBtnStyles;
        if (variant === "secondary-on-grey") return { ...secondaryBtnStyles, border: props.isActive ? "1px solid #008755" : "1px solid #CFD0CF" };
        return "noop";
    })();
    return mq({
        ...variantStyles,
        ...getCssProps(props)
    });
});

export const Tag = styled.div`
    background: ${props => props.backgroundColor};
    display: inline-block;
    border-radius: 5px;
    font-size: 12px;
    padding: 5px 8px 5px 22px;
    line-height: 20px;
    position: relative;
    &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translateY(-50%);
        width: 6px;
        height: 6px;
        background-color: ${props => props.dotColor};
        border-radius: 50%;
    }
`;
